import { useQueryClient, useMutation } from 'react-query';
import SchemaPhoneTreeService from '@frontend/api-phone-trees';
import { SchemaIO } from '@frontend/schema';
import { queryKeys } from '../../query-keys';

export type PhoneTreeCreatePayload = SchemaIO<(typeof SchemaPhoneTreeService)['Create']>['input'];
export type PhoneTreeUpdateState = SchemaIO<(typeof SchemaPhoneTreeService)['Update']>['input'];
export type PhoneTreeDialOptionState = SchemaIO<(typeof SchemaPhoneTreeService)['UpdateDialOptions']>['input'];

export const usePhoneTreeMutations = (phoneTenantId: string) => {
  const queryClient = useQueryClient();

  const create = useMutation({
    mutationFn: (payload: PhoneTreeCreatePayload) => {
      return SchemaPhoneTreeService.Create(payload);
    },
    onSettled: () => {
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listPhoneTrees()]);
    },
  });

  const update = useMutation({
    mutationFn: (payload: PhoneTreeUpdateState) => {
      return SchemaPhoneTreeService.Update(payload);
    },
  });

  const updateDialOptions = useMutation({
    mutationFn: (payload: PhoneTreeDialOptionState) => {
      return SchemaPhoneTreeService.UpdateDialOptions(payload);
    },
  });

  const remove = useMutation({
    mutationFn: (payload: { phoneTreeId: string }) => {
      return SchemaPhoneTreeService.Delete(payload);
    },
    onSettled: (_data, _err, payload) => {
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listPhoneTrees()]);
      queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.readPhoneTree(payload.phoneTreeId)]);
    },
  });

  const invalidatePhoneTreeQueries = (phoneTreeId: string) => {
    queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.listPhoneTrees()]);
    queryClient.invalidateQueries([phoneTenantId, ...queryKeys.settings.readPhoneTree(phoneTreeId)]);
  };

  return {
    create,
    update,
    updateDialOptions,
    remove,
    invalidatePhoneTreeQueries,
  };
};
